module.exports = __webpack_public_path__ + "static/img/y_szrl44.46bf89d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/y_szrl44.png
// module id = u+ka
// module chunks = 73